import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { AsyncErrorHandler } from 'lib/ui';
import { Models } from 'models/core';
import { ConsumptionMaterialWashingService } from 'services/consumption-material-washing-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class ConsumptionMaterialWashingDetail {
  private consumptionMaterialWashing: Models.ConsumptionMaterialWashing;
  protected checkDuplicateData: Models.CheckDuplicateConsumptionMaterialWashing = new Models.CheckDuplicateConsumptionMaterialWashing();

  constructor(
    private consumptionMaterialWashingService: ConsumptionMaterialWashingService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private confirmation: ConfirmDialog
  ) {}

  async activate(params: { Id: number }) {
    this.consumptionMaterialWashing = await this.consumptionMaterialWashingService.get(params.Id);
  }

  @AsyncErrorHandler
  async updateConsumptionMaterialWashing() {
    if (await this.checkDuplicate()) return;
    await this.consumptionMaterialWashingService.put(this.consumptionMaterialWashing, this.consumptionMaterialWashing.Id);
    this.eventAggregator.publish('consumableWashListReset', 1);
    this.toastService.showSuccess('consumptionMaterialWashing.updated');
    this.router.navigateToRoute('service-consumption-material-washing-list');
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.Id = this.consumptionMaterialWashing.Id;
    this.checkDuplicateData.ProductId = this.consumptionMaterialWashing.ProductId;
    const { IsDuplicate } = await this.consumptionMaterialWashingService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('consumptionMaterialWashingIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }

  @AsyncErrorHandler
  async deleteConsumptionMaterialWashing() {
    const confirmation = await this.confirmation.confirmDelete();
    if (!confirmation) return;
    await this.consumptionMaterialWashingService.delete(this.consumptionMaterialWashing.Id);
    this.eventAggregator.publish('consumableWashListReset', 1);
    this.toastService.showSuccess('consumptionMaterialWashing.deleted');
    this.router.navigateToRoute('service-consumption-material-washing-list');
  }

  gotoParentView() {
    this.eventAggregator.publish('consumableWashListReset', 1);
    this.router.navigateToRoute('service-consumption-material-washing-list');
  }
}
